import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import gallaryImgOne from '../assets/ronke.jpeg';
import ProjectSlider from '../components/ProjectSlider';
import React, { useState, useEffect, useRef } from 'react'

const AboutView = () => {
  const [isNavbarOutOfView, setIsNavbarOutOfView] = useState(false);
  const [isEndOfContent, setIsEndOfContent] = useState(false);
  const textContainerRef = useRef<HTMLDivElement | null>(null);
  const navbarRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsNavbarOutOfView(!entry.isIntersecting);
      },
      { threshold: 0 }
    );

    if (navbarRef.current) {
      observer.observe(navbarRef.current);
    }

    return () => {
      if (navbarRef.current) {
        observer.unobserve(navbarRef.current);
      }
    };
  }, []);

  
  useEffect(() => {
    const handleScroll = () => {
      if (textContainerRef.current) {
        const textBottom = textContainerRef.current.getBoundingClientRect().bottom;
        setIsEndOfContent(textBottom <= window.innerHeight);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <main className='bg-[#FFFAE5]'>
        <section ref={navbarRef}>
          <Navbar inverse={true} />
        </section>

        <header>
          <section className="flex flex-col lg:flex-row gap-x-8">
            <div className="lg:sticky lg:min-w-[650px]">
              <div
                className={`${isEndOfContent
                    ? 'lg:absolute lg:bottom-0'
                    : `lg:fixed ${isNavbarOutOfView ? 'lg:top-1' : 'lg:top-16'}`
                  } lg:min-w-[650px] transition-all duration-500 ease-linear`}
              >
                <div
                  className="w-full min-h-[420px] md:min-h-[590px] bg-left-top bg-no-repeat bg-cover"
                  style={{ backgroundImage: `url(${gallaryImgOne})` }}
                ></div>
              </div>
            </div>

            <div ref={textContainerRef} className="lg:w-5/12 p-3 space-y-8 pt-8 lg:pt-72">
              <article className="space-y-4">
                <h1 className="uppercase tf-rozha font-semibold text-4xl md:text-5xl">Back Story</h1>
                <p className="tf-inter font-light text-sm md:text-base leading-loose tracking-widest">Prophetess Ronke akin ooye is a woman with multi talented skills. She is a wife, mother, Prophetess, writer, producer, motivational speaker and a business woman.</p>
                <p className="tf-inter font-light text-sm md:text-base leading-loose tracking-widest">She is the set woman of Wise Christian family prophetic mission chuch aka Wise Family and Narca lnternational, an online women praying group. She runs outreach locally and internationally.</p>
                <p className="tf-inter font-light text-sm md:text-base leading-loose tracking-widest">Abiyamo Pot, a children  evangelism outreach , preaching the love of christ, sharing goodie bags, used clothing items. Abiyamo conference both in Nigeria and United Kingdom.</p>
              </article>

              <article className="space-y-2">
                {/* <h1 className="uppercase tf-rozha font-medium text-3xl md:text-4xl">Brief history</h1> */}
                <p className="tf-inter font-light leading-loose tracking-widest text-sm md:text-base">
                She runs a  widows fellowship quaterly tagged wise grandma, we share food and provisions.Wise family is a family church, existing for the past 10 years, we pray, build and eat together, encouraging youths to be empowered and get educated.
                </p>
              </article>

              {/* <article className="space-y-4">
                <h1 className="uppercase tf-rozha font-medium text-3xl md:text-4xl">Another segment</h1>
                <p className="tf-inter font-light leading-snug tracking-widest text-sm md:text-base">
                Lorem ipsum dolor sit amet consectetur. Aenean quis ornare velit vel ipsum venenatis porta porttitor. Sit netus eget velit ullamcorper lobortis est sapien. Euismod eget congue vivamus aliquam donec mi. Consequat nam sit eget mauris ut est pellentesque. Hac venenatis tristique venenatis molestie. Elementum nisl sollicitudin sit mattis egestas. Dui sed enim in velit iaculis diam mi. Aliquam accumsan dui id egestas. Ut cras elementum nunc netus eget eu id quam viverra. Facilisis diam quam vitae volutpat mauris.
                </p>
              </article> */}
            </div>
          </section>


          <section className='mt-20 pb-24 w-full md:w-9/12 xl:w-10/12 mx-auto'>
            <ProjectSlider />
          </section>

        </header>

      </main>

      <Footer />
    </>
  )
}

export default AboutView